module.exports = (__webpack_require__(20))(54);


//////////////////
// WEBPACK FOOTER
// delegated ./plugins/jobs/web_client/JobStatus.js from dll-reference girder_plugin_jobs
// module id = 17
// module chunks = 0